// @owners { team: patients-team }
import { ActionSheetV2 } from '@alto/design-system';
import React from 'react';
import { ORGANIC_ONBOARDING_STEPS } from '~shared/constants';
import { useCommunicationPreferencesViewed } from '~shared/lib/analytics/src/hooks/useCommunicationPreferencesViewed';
import { type User } from '~shared/types';
import { OnboardingHealthProfileForm } from './OnboardingHealthProfileForm';
import { OnboardingInsuranceForm } from './OnboardingInsuranceForm';
import { ProgressIndicator } from '~web/components/legacy/ProgressIndicator';
import { CommunicationPreferencesForm } from '~web/features/profile/components/CommunicationPreferencesForm';

export const getOrganicOnboardingStep = ({ allergies, allergens, medical_conditions }: User) => {
  // If the user has not filled out their allergies or specified no allergies, move them back to the health profile step.
  const filledOutAllergies = allergies !== null || (Array.isArray(allergens) && allergens.length > 0);
  if (!filledOutAllergies || !medical_conditions) {
    return ORGANIC_ONBOARDING_STEPS.HEALTH_PROFILE;
  }

  return ORGANIC_ONBOARDING_STEPS.COMMUNICATION_PREFERENCES;
};

export const OnboardingMedicalInfoActionSheet = () => {
  return (
    <ActionSheetV2
      title="Medical info"
      analyticsName="organic_onboarding_medical_info"
      dismissible={false}
    >
      <ProgressIndicator
        totalSteps={3}
        currentIndex={ORGANIC_ONBOARDING_STEPS.HEALTH_PROFILE}
      />
      <OnboardingHealthProfileForm />
    </ActionSheetV2>
  );
};

export const OnboardingInsuranceActionSheet = () => {
  return (
    <ActionSheetV2
      title="Benefits"
      analyticsName="organic_onboarding_benefits"
      dismissible={false}
    >
      <ProgressIndicator
        totalSteps={3}
        currentIndex={ORGANIC_ONBOARDING_STEPS.INSURANCE_FORM}
      />
      <OnboardingInsuranceForm />
    </ActionSheetV2>
  );
};

export const OnboardingCommsPreferencesActionSheet = () => {
  useCommunicationPreferencesViewed();

  return (
    <ActionSheetV2
      title="Communication preferences"
      analyticsName="organic_onboarding_comms_preferences"
      dismissible={false}
    >
      <ProgressIndicator
        totalSteps={3}
        currentIndex={ORGANIC_ONBOARDING_STEPS.COMMUNICATION_PREFERENCES}
      />
      <CommunicationPreferencesForm isOnboarding />
    </ActionSheetV2>
  );
};
